// Accepting a reservation (inbound, callback or transfer) dials
// task_router:<task_sid>:<task_type>:<communication_id> into the conference.
export const RESERVATION_DIAL_PREFIX = 'task_router:'

// TaskRouter task_type values from task attributes.
// Used for inbound calls, callbacks, and call transfers (cold/warm).
export const INBOUND_CALL = 'inbound_call'
export const CALLBACK = 'callback'
export const COLD_TRANSFER = 'cold_transfer'
export const WARM_TRANSFER = 'warm_transfer'

export const TRANSFER_TASK_TYPES = [COLD_TRANSFER, WARM_TRANSFER]

export const UNPARK = 'unpark'
export const OUTBOUND_CALL = 'outbound_call'

// Reservations that are answered by the tab that raised them rather than offered to the
// agent. OUTBOUND_CALL is deliberately absent: a server-initiated outbound call (public
// API, sequence, HubSpot workflow) must ring the agent and be accepted, the way the
// legacy engine's agent leg did.
export const AUTO_ANSWER_TASK_TYPES = [UNPARK]
